<template>
  <VueFinalModal
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :clickToClose="!submitting"
    :escToClose="!submitting"
    classes="documents-modal"
    content-class="confirm-modal-content modal--procure"
  >
    <template #default>
      <button
        class="modal__close icons-button"
        @click="close"
        :disabled="submitting"
        title="Chiudi"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>

      <h3 class="modal__title">Ordina articolo</h3>
      <p class="modal__subtitle">{{ title }}</p>

      <label class="procure-field">
        <span>Quantità arrivata ({{ unit }})</span>
        <input
          type="number"
          v-model.number="quantity"
          :min="1"
          :max="maxQuantity"
          step="1"
          :disabled="submitting"
        />
      </label>

      <p class="procure-hint">
        Da ordinare: {{ maxQuantity }} {{ unit }}. Un arrivo parziale lascia la
        consegna bloccata sul residuo.
      </p>

      <p v-if="error" class="procure-error">{{ error }}</p>

      <div class="modal-actions">
        <button class="secondary-btn" @click="close" :disabled="submitting">
          Annulla
        </button>
        <button
          class="primary-btn confirm-btn"
          @click="confirm"
          :disabled="submitting || !isValid"
        >
          <span v-if="submitting">Ordina…</span>
          <span v-else>Ordina</span>
        </button>
      </div>
    </template>
  </VueFinalModal>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";

export default {
  name: "ProcureModal",
  components: { VueFinalModal },
  props: {
    modelValue: { type: Boolean, default: false },
    title: { type: String, default: "" },
    maxQuantity: { type: Number, default: 0 },
    unit: { type: String, default: "pz" },
    submitting: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "confirm"],

  data() {
    return {
      quantity: this.maxQuantity,
      error: "",
    };
  },

  computed: {
    isValid() {
      const n = Number(this.quantity);
      return Number.isInteger(n) && n >= 1 && n <= this.maxQuantity;
    },
  },

  watch: {
    // Alla riapertura la quantità riparte dal residuo corrente.
    modelValue(open) {
      if (open) {
        this.quantity = this.maxQuantity;
        this.error = "";
      }
    },
  },

  methods: {
    close() {
      if (this.submitting) return;
      this.$emit("update:modelValue", false);
    },

    confirm() {
      if (!this.isValid) {
        this.error = `Inserire un intero fra 1 e ${this.maxQuantity}.`;
        return;
      }
      this.error = "";
      this.$emit("confirm", Number(this.quantity));
    },
  },
};
</script>

<style scoped>
.procure-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin: 1rem 0 0.5rem;
}

.procure-field input {
  padding: 0.5rem;
  border: 1px solid var(--border-color, #ccc);
  border-radius: 6px;
}

.procure-hint {
  font-size: 0.85rem;
  opacity: 0.75;
  margin-bottom: 0.5rem;
}

.procure-error {
  color: var(--danger-color, #c0392b);
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
}
</style>
